import { createApp, h } from 'vue';
import { reactive } from 'vue';
import router from './router';
import PrimeVue from 'primevue/config';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Checkbox from 'primevue/checkbox';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import FileUpload from 'primevue/fileupload';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import ProgressBar from 'primevue/progressbar';
import RadioButton from 'primevue/radiobutton';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import BlockUI from 'primevue/blockui';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primevue/resources/primevue.min.css';
import 'prismjs/themes/prism-coy.css';
import './assets/fonts/MyDimercoFonts.css'
import './assets/css/MyDimerco.css'



router.beforeEach(function(to, from, next) {
    window.scrollTo(0, 0);
    next();
});

import GetAQuote from './pages/GetQuote';


const app = createApp({
    computed: {
        ViewComponent () {
			switch (this.$route.path) {
				
				case '/getaquote':
				default:
					return GetAQuote;									
			}
		}
    },
    render () { return h(this.ViewComponent) }
});
app.config.globalProperties.$appState = reactive({ inputStyle: 'outlined' });

app.use(PrimeVue, { ripple: true});

app.use(ToastService);
app.use(router);
app.component('AutoComplete', AutoComplete);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Card', Card);
app.component('Checkbox', Checkbox);
app.component('Dialog', Dialog);
app.component('Dropdown', Dropdown);
app.component('FileUpload', FileUpload);
app.component('InputNumber', InputNumber);
app.component('InputText', InputText);
app.component('ProgressBar', ProgressBar);
app.component('RadioButton', RadioButton);
app.component('Textarea', Textarea);
app.component('Toast', Toast);
app.component('BlockUI', BlockUI);
app.config.productionTip = false
app.mount('#app');